<div class="breadcrumb" role="menu" attr.aria-label="breadcrumbs" *ngIf="currentUrl != '/sessionExpired'">
    <div *ngFor="let breadcrumb of breadcrumbs" routerLinkActive="router-link-active"
        [ngClass]="{'breadcrumb-visited': breadcrumb.visited }" tabindex="0" attr.aria-label="{{ 'breadcrumb.label' }}">
        <span class="breadcrumb__inner">
            <span> {{ breadcrumb.label | translateSplit}}</span>
        </span>
    </div>
</div>